<template>
  <div class="check-id">
    <h1 class="title">找回密码</h1>
    <div style="width:340px;margin:0 auto;" class="change-loginPass">
      <div>
        <el-form :model="changePass" ref="changePass" :rules="rules" label-width="0px" class="check-info">
          <el-form-item prop="newPass">
            <el-input type="password" v-model="changePass.newPass" placeholder="请输入新密码"></el-input>
          </el-form-item>
          <el-form-item prop="confirmPass">
            <el-input type="password" v-model="changePass.confirmPass" placeholder="请再次输入新密码"></el-input>
          </el-form-item>
          <div style="text-align:center;">
            <el-button type="primary" style="width:100px;background:#1060ab;font-size:16px;margin-top:33px;" @click="changePassword">确定</el-button>
            <p style="color:#999999">如果无法自己找回，请联系培训中心管理员。</p>
          </div>
        </el-form>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    const pwCheck = (rule, value, callback) => {
      if (!this.changePass.newPass) {
        callback(new Error("请输入新密码"));
      } else if (
        !/^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{8,16}$/.test(
          this.changePass.newPass
        )
      ) {
        callback(new Error("请输入8-16位，数字和字母的组合"));
      } else {
        callback();
      }
    }
    const rePwCheck = (rule, value, callback) => {
      if (
        !/^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{8,16}$/.test(
          this.changePass.newPass
        )
      ) {
        callback(new Error("密码格式错误"));
      } else if (
        this.changePass.newPass !== this.changePass.confirmPass
      ) {
        callback(new Error("两次输入的密码不一致"));
      } else {
        callback();
      }
    }
    return {
      changePass: {
        newPass: '',
        confirmPass: ''
      },
      rules: {
        newPass: [
          // {required: true, message: '请输入密码', trigger: 'blur'},
          { required: true, validator: pwCheck, trigger: "blur" }
        ],
        confirmPass: [
          { required: true, message: "请确认新密码", trigger: "blur" },
          { validator: rePwCheck, trigger: "blur" }
        ]
      }
    }
  },
  created () {
    if (sessionStorage.step !== 'infoChecked') {
      this.$router.push('/')
    }
  },
  mounted () {
  },
  methods: {
    changePassword () {
      this.$refs['changePass'].validate(valid => {
        if (valid) {
          this.$ajax
            .post(
              '/comuser-service/Account/updatesPasswordByPassWord',
              this.postData({
                id: sessionStorage.userId,
                newPassword: this.changePass.newPass
              })
            )
            .then(res => {
              if ((res.code === '200')) {
                this.$message({
                  message: "验证成功",
                  type: "success"
                })
                setTimeout(() => {
                  sessionStorage.step = 'passChecked'
                  this.$router.push('/FindPass/ChangeDone')
                }, 1000)
              } else {
                this.$message.error(res.message)
              }
            })
        }
      })
    },
    contactAdmin () {
      this.$router.push('/FindPass/ContactAdmin')
    }
  }
}
</script>
<style lang="scss">
.check-id {
  width: 1020px;
  margin: 0 auto;
  background: rgb(255, 255, 255);
  .title {
    font-weight: normal;
    font-size: 24px;
    margin: 30px 40px;
    color: #333333;
    border-bottom:1px solid #eeeeee;
    padding-bottom: 20px;
    margin-bottom:90px;
  }
  .check-info {
    margin-bottom:33px;
    .el-form-item__label {
      font-size: 16px;
      color: #333333;
    }
    .el-input {
      width: 340px;
    }
  }
}
</style>





// WEBPACK FOOTER //
// src/views/findPass/changePassword.vue